import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { sendCommerceNewRelicError as sendNewRelicErrorBase } from '@chegg/commerce-utils';
import { ProjectName } from '../constants/AppConstants';

/**
 * New Relic Logging Util
 * @param message
 * @param extras
 */
export var NewRelicComponentVersion = '4.32.49';
export var sendNewRelicError = function sendNewRelicError(message, extras) {
  sendNewRelicErrorBase({
    error: message,
    componentName: ProjectName,
    componentVersion: NewRelicComponentVersion,
    extras: _objectSpread({
      referrer: typeof document !== 'undefined' ? document.location.href : ''
    }, extras)
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/NewRelicUtils.js
// module id = 1488
// module chunks = 11